module.exports = __webpack_public_path__ + "gif/correct-1.gif";